import { useState, useEffect, useContext } from "react";
import { ImageContext } from "../Component/Context/ImageContext";
import { createPattern } from "../Component/Desktop/createPattern";
import { 
  COLOURBOND_COLORS, 
  PLATINUM_COLORS, 
  NATIVE_COLORS, 
  COMPOSITE_COLORS 
} from "../Constants/constants";

export const useMobileDoorLogic = (selectedDoor) => {
  const { cropImage, setImgurl } = useContext(ImageContext);
  
  // State management
  const [selectedColor, setSelectedColor] = useState("#5f1d0f");
  const [selectedPattern, setSelectedPattern] = useState("sectional");
  const [selectSeries, setSelectseries] = useState("Essentials");
  const [selectedDesign, setSelectedDesign] = useState("Oxford");
  const [PanelStyle, setPanelStyle] = useState("");
  const [selectedColorName, setSelectedColorName] = useState("Manor Red");
  const [selctwindow, setSelectWindow] = useState("");
  const [SelectedMaterial, setSelectedMaterial] = useState("Composite");
  const [bgImage, setBgImage] = useState(null);
  const [image, setImage] = useState(null);
  const [doorWidth, setDoorWidth] = useState("double door");
  
  const [points, setPoints] = useState(
    selectedDoor || [
      { x: 150, y: 150 }, // top-left
      { x: 300, y: 150 }, // top-right
      { x: 300, y: 250 }, // bottom-right
      { x: 150, y: 250 }, // bottom-left
    ]
  );

  // Set background image from context
  useEffect(() => {
    if (cropImage) {
      setBgImage(cropImage);
    }
  }, [cropImage]);

  // Apply door design function
  const applyDoorDesign = async (
    color = selectedColor,
    pattern = selectedPattern,
    design = selectedDesign,
    series = selectSeries,
    panelStyle = PanelStyle,
    windowstyle = selctwindow,
    material = SelectedMaterial
  ) => {
    const patternFill = await createPattern(
      color,
      pattern,
      design,
      series,
      panelStyle,
      windowstyle,
      material
    );
    if (patternFill) {
      setImage(patternFill);
    }
  };

  // Handle color change from dropdown
  const handleColorChange = (selectedBgColor) => {
    if (!selectedBgColor) return;

    // Combine all colors into one array
    const allColors = [
      ...COLOURBOND_COLORS,
      ...PLATINUM_COLORS,
      ...NATIVE_COLORS,
      ...COMPOSITE_COLORS,
    ];
    
    const selectedItem = allColors.find(
      (color) => color.bgcolor === selectedBgColor
    );

    if (selectedItem) {
      setSelectedColor(selectedItem.bgcolor);
      setSelectedColorName(selectedItem.name);
    }
  };

  // Handle series change logic
  const handleSeriesChange = (newSeries) => {
    let newDesign = selectedDesign;
    let newPanelStyle = PanelStyle;
    let newWindowStyle = selctwindow;
    let newmaterial = SelectedMaterial;

    if (newSeries === "Essentials") {
      newDesign = "Oxford";
      newPanelStyle = "";
    } else if (newSeries === "Native") {
      newDesign = "Madison";
      newPanelStyle = "";
      newWindowStyle = "";
    } else if (newSeries === "Selections Series") {
      newPanelStyle = "Alumicomp";
      newDesign = "Sovereign";
      newWindowStyle = "";
      newmaterial = "Composite";
    }

    setSelectseries(newSeries);
    setSelectedDesign(newDesign);
    setPanelStyle(newPanelStyle);
    setSelectWindow(newWindowStyle);
    setSelectedMaterial(newmaterial);

    applyDoorDesign(
      selectedColor,
      newSeries,
      newDesign,
      newPanelStyle,
      newWindowStyle,
      newmaterial
    );
  };

  // Handle pattern change logic
  const handlePatternChange = (patternName) => {
    setSelectedPattern(patternName);
    applyDoorDesign(selectedColor, patternName);

    if (patternName === "sectional") {
      setSelectseries("Essentials");
      setSelectedDesign("Oxford");
    }
    if (patternName === "roller") {
      setSelectseries("");
      setSelectedDesign("");
      setPanelStyle("");
      setSelectWindow("");
    }
  };

  // Reset to default values
  const resetToDefault = () => {
    setSelectedColorName("Manor Red");
    setSelectedPattern("sectional");
    setSelectedDesign("Oxford");
    setSelectedColor("#5f1d0f");
    setPanelStyle("");
    setSelectseries("Essentials");
    setSelectWindow("");
  };

  // Apply door design effect
  useEffect(() => {
    applyDoorDesign();
  }, [
    selectedColor,
    selectedPattern,
    selectedDesign,
    selectSeries,
    PanelStyle,
    selctwindow,
    SelectedMaterial,
  ]);

  return {
    // State values
    selectedColor,
    selectedPattern,
    selectSeries,
    selectedDesign,
    PanelStyle,
    selectedColorName,
    selctwindow,
    SelectedMaterial,
    bgImage,
    image,
    doorWidth,
    points,
    
    // State setters
    setSelectedColor,
    setSelectedPattern,
    setSelectseries,
    setSelectedDesign,
    setPanelStyle,
    setSelectedColorName,
    setSelectWindow,
    setSelectedMaterial,
    setBgImage,
    setImage,
    setDoorWidth,
    setPoints,
    
    // Logic functions
    applyDoorDesign,
    handleColorChange,
    handleSeriesChange,
    handlePatternChange,
    resetToDefault,
  };
};